<template>
  <a-modal
    class="form-confirm-modal"
    :visible.sync="visibleModal"
    :width="366"
    :title="formConfig.title || ''"
    :confirm-loading="btnLoading"
    :afterClose="handleAfterClose"
    @ok="handleConfirm"
    @cancel="handleCancel"
    ok-text="确认"
    cancel-text="取消"
  >
    <a-form-model
      v-if="formConfig.form"
      ref="ruleForm"
      layout="horizontal"
      :hideRequiredMark="true"
      :model="formConfig.form"
      :rules="formConfig.formRules"
      :label-col="formConfig.labelCol"
      :wrapper-col="formConfig.wrapperCol"
      labelAlign="right"
    >
      <a-form-model-item
        style="display: flex;"
        v-for="(fieldValue, fieldKey) in formConfig.form"
        :key="fieldKey"
        :label="formConfig.formFieldObj[fieldKey].label"
        :prop="fieldKey"
      >
        <a-input
          v-if="formConfig.formFieldObj[fieldKey].type == 'input'"
          v-model="formConfig.form[fieldKey]"
          :placeholder="
            formConfig.formFieldObj[fieldKey].placeholder || '请输入'
          "
        />
        <a-select
          v-if="formConfig.formFieldObj[fieldKey].type == 'select'"
          v-model="formConfig.form[fieldKey]"
          :placeholder="
            formConfig.formFieldObj[fieldKey].placeholder || '请选择'
          "
        >
          <a-select-option
            v-for="item in formConfig.formFieldObj[fieldKey].options"
            :key="item.id"
          >
            {{ item.name || "--" }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  props: {
    visibleModal: {
      type: Boolean,
      default: false
    },
    formConfig: {
      type: Object,
      default: () => {
        return this.defaultFormConfig;
      }
    }
  },
  data() {
    return {
      btnLoading: false,
      defaultFormConfig: {
        title: "",
        handleConfirm: () => {
          this.$emit("update:visibleModal", false);
        },
        handleCancel: () => {
          this.$emit("update:visibleModal", false);
        },
        handleAfterClose: () => {
          this.$emit("update:visibleModal", false);
        }
      }
    };
  },
  watch: {
    visibleModal(val) {
      if (val) {
        this.resetFields();
      }
    }
  },
  methods: {
    resetFields() {
      let formRef = this.$refs["ruleForm"];
      if (formRef) formRef.resetFields();
    },
    handleConfirm() {
      if (this.formConfig.handleConfirm) {
        this.formConfig.handleConfirm(this);
      } else {
        this.defaultFormConfig.handleConfirm();
      }
    },
    handleCancel() {
      if (this.formConfig.handleCancel) {
        this.formConfig.handleCancel(this);
      } else {
        this.defaultFormConfig.handleCancel();
      }
    },
    handleAfterClose() {
      if (this.formConfig.handleAfterClose) {
        this.formConfig.handleAfterClose(this);
      } else {
        this.defaultFormConfig.handleAfterClose();
      }
    }
  }
};
</script>
